// extracted by mini-css-extract-plugin
export default {"authSide":"auth_authSide__dAFuP","authCopy":"auth_authCopy__VmIbS"};